import eventbus from '@/utils/eventbus';

export default function (options) {
  eventbus.emit('openSocialModal', options);
}
